<div style="height: 100%; max-height:100%">
    <p-tabView [activeIndex]="0" (onChange)="onTableChange($event)">
        <p-tabPanel header="Open">
            <div class="flex overflow-y-scroll h-auto flex-column gap-2">
                <div class="p-2">
                    <span class="mr-2">Include Diaries Due Within</span>
                    <span class="mr-2">
                        <p-dropdown [(ngModel)]="dueDateLookaheadDays" appendTo="body" [options]="dayRanges" (onChange)="refreshOpen()"></p-dropdown>
                    </span>
                    <span>Days</span>
                </div>
                <p-table [value]="(diaryItems$ | async) ?? []" dataKey="id" class="w-full" sortField="dueDate" [sortOrder]="1">
                    <ng-template pTemplate="header">
                        <tr>
                            <th></th>
                            <th style="width:12rem"><p>Encounter Id</p><p>{{useMember ? 'Member' : 'Injured Worker'}}</p></th>
                            <th style="width:8rem">Status</th>
                            <th pSortableColumn="dueDate">Due Date <p-sortIcon field="dueDate" /></th>
                            <th>Summary</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-diaryItem let-expanded="expanded">
                        <tr>
                            <td>
                                <p-button type="button" pRipple [pRowToggler]="diaryItem" [text]="true" [rounded]="true" [plain]="true" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" />
                            </td>
                            <td>
                                <p><a (click)="diaryItem.goToRelatedItem()">{{diaryItem.getDiary().encounterId}}</a></p>
                                <p-skeleton *ngIf="diaryItem.getDiary().encounterId == null" width="10rem" styleClass="mb-2" /> 
                                <span *ngIf="diaryItem.getDiary().encounterId != null">{{  diaryItem.getRelatedToText()}}</span>
                            </td>
                            <td>
                                <p-tag *ngIf="diaryItem.getDiary().assignedTo == null && diaryItem.getDiary().closedDate == null && diaryItem.getDiary().createdBy.id !== systemUserId" 
                                severity="success" icon="pi pi-star-fill" [rounded]="true" value="New" />
                                <p-tag
                                    *ngIf="diaryItem.getDiary().assignedTo != null && diaryItem.getDiary().dueDate != null && diaryItem.getDiary().closedDate == null && diaryItem.getDiary().createdBy.id === systemUserId"
                                    [style]="{'background-color':'#8b5cf6','color':'#ffffff'}" icon="pi pi-cog" [rounded]="true" value="System" />
                                <p-tag
                                    *ngIf="diaryItem.getDiary().assignedTo != null && diaryItem.getDiary().dueDate != null && diaryItem.getDiary().closedDate == null && isDueToday(diaryItem.getDiary().dueDate) && diaryItem.getDiary().createdBy.id !== systemUserId"
                                    [style]="{'background-color':'#00009f','color':'#ffffff'}" icon="pi pi-clock" [rounded]="true" value="Today" />
                                <p-tag
                                    *ngIf="diaryItem.getDiary().assignedTo != null && diaryItem.getDiary().dueDate != null && diaryItem.getDiary().closedDate == null && !isDueToday(diaryItem.getDiary().dueDate) && now <= diaryItem.getDiary().dueDate && diaryItem.getDiary().createdBy.id !== systemUserId"
                                    [style]="{'background-color':'#009f00','color':'#fff'}" icon="pi pi-user" [rounded]="true" value="Active" />
                                <p-tag
                                    *ngIf="diaryItem.getDiary().assignedTo != null && diaryItem.getDiary().dueDate != null && diaryItem.getDiary().closedDate == null && !isDueToday(diaryItem.getDiary().dueDate) && now > diaryItem.getDiary().dueDate && diaryItem.getDiary().createdBy.id !== systemUserId"
                                    severity="danger" icon="pi pi-exclamation-triangle" [rounded]="true" value="Overdue" />
                                <p-tag *ngIf="diaryItem.getDiary().closedDate != null" severity="secondary" icon="pi pi-check" [rounded]="true" value="Closed" />
                            </td>
                            <td>{{diaryItem.getDiary().dueDate | date:'shortDate'}}</td>
                            <td>{{diaryItem.getDiary().subject}}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="rowexpansion" let-diaryItem>
                        <tr>
                            <td colspan="5">
                                <div class="flex flex-column">
                                    <div class="flex flex-row m-2">
                                        <div>
                                            Created: {{diaryItem.getDiary().createdDate | date:'shortDate'}}
                                        </div>
                                    </div>
                                    <div class="flex flex-row gap-2 w-full">
                                        <div class="diary-body h-9rem flex-1 border-solid text-sm border-round border-200 p-2 pl-4 pr-4 overflow-y-scroll overflow-x-hidden" style="min-width:0" [innerHtml]="diaryItem.getDiary().body"></div>
                                        <div class="flex flex-shrink-0 flex-column gap-2">
                                            <p-button icon="pi pi-external-link" [outlined]="true" pTooltip="Go to related item" tooltipPosition="left" (click)="diaryItem.goToRelatedItem()"></p-button>
                                            <p-button icon="pi pi-times" [outlined]="true" pTooltip="Close diary" tooltipPosition="left" (click)="closeDiary(diaryItem)"></p-button>
                                            <p-confirmDialog></p-confirmDialog>
                                            <p-button icon="pi pi-user" [outlined]="true" pTooltip="Reassign diary" tooltipPosition="left"
                                                    (click)="assignDiaryOp.toggle($event)"
                                                    [disabled]="isReassignDisabled(diaryItem)"></p-button>
                                            <p-overlayPanel appendTo="body" #assignDiaryOp>
                                                <div>
                                                    <div class="flex pt-3 grid">
                                                        <div class="field col-5">
                                                            <p-floatLabel>
                                                                <p-calendar #selectedDueDate [ngModel]="diaryItem.getDiary().dueDate" id="dueDate" [style]="{'width':'100%'}"></p-calendar>
                                                                <label for="dueDate">Due Date</label>
                                                            </p-floatLabel>
                                                        </div>
                                                        <div class="col-5 field">
                                                            <p-dropdown #selectedAssignee dataKey="id" [ngModel]="diaryItem.getDiary().assignedTo" [options]="(activeUsers$ | async) ?? []" optionLabel="fullName" [style]="{'width':'100%'}"></p-dropdown>
                                                        </div>
                                                        <div class="col-2">
                                                            <p-button icon="pi pi-check" [disabled]="selectedDueDate.value == null || selectedAssignee.value == null || selectedDueDate.value < now" (onClick)="assignDiary(diaryItem,selectedAssignee.value,selectedDueDate.value)"></p-button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </p-overlayPanel>
                                        </div>
                                        
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </p-tabPanel>
        <p-tabPanel header="Closed">
            <div class="flex overflow-y-scroll h-auto flex-column gap-2">
                <div class="p-2">
                    <span class="mr-2">Include Diaries Closed Within</span>
                    <span class="mr-2">
                        <p-dropdown [(ngModel)]="closedDateLookbackDays" appendTo="body" [options]="dayRanges" (onChange)="refreshClosed()"></p-dropdown>
                    </span>
                    <span>Days</span>
                </div>
                
                <p-table [value]="(closedDiaryItems$ | async)  ?? []" dataKey="id" class="w-full" sortMode="single" sortField="closedDate" [sortOrder]="-1">
                    <ng-template pTemplate="header">
                        <tr>
                            <th></th>
                            <th style="width:12rem"><p>Encounter Id</p><p>{{useMember ? 'Member' : 'Injured Worker'}}</p></th>
                            <th style="width:8rem">Status</th>
                            <th pSortableColumn="closedDate">Closed Date <p-sortIcon field="closedDate" /></th>
                            <th>Summary</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-diaryItem let-expanded="expanded">
                        <tr>
                            <td>
                                <p-button type="button" pRipple [pRowToggler]="diaryItem" [text]="true" [rounded]="true" [plain]="true" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" />
                            </td>
                            <td>
                                <p>{{diaryItem.getDiary().encounterId}}</p>
                                <p-skeleton *ngIf="diaryItem.getDiary().encounterId == null" width="10rem" styleClass="mb-2" /> 
                                <span *ngIf="diaryItem.getDiary().encounterId != null">{{  diaryItem.getRelatedToText()}}</span>
                            </td>
                            <td>
                                <p-tag *ngIf="diaryItem.getDiary().assignedTo == null && diaryItem.getDiary().closedDate == null" severity="success"
                                    icon="pi pi-star-fill" [rounded]="true" value="New" />
                                <p-tag
                                    *ngIf="diaryItem.getDiary().assignedTo != null && diaryItem.getDiary().dueDate != null && diaryItem.getDiary().closedDate == null && isDueToday(diaryItem.getDiary().dueDate)"
                                    severity="warning" icon="pi pi-clock" [rounded]="true" value="Due Today" />
                                <p-tag
                                    *ngIf="diaryItem.getDiary().assignedTo != null && diaryItem.getDiary().dueDate != null && diaryItem.getDiary().closedDate == null && !isDueToday(diaryItem.getDiary().dueDate) && now <= diaryItem.getDiary().dueDate"
                                    severity="info" icon="pi pi-user" [rounded]="true" value="Assigned" />
                                <p-tag
                                    *ngIf="diaryItem.getDiary().assignedTo != null && diaryItem.getDiary().dueDate != null && diaryItem.getDiary().closedDate == null && !isDueToday(diaryItem.getDiary().dueDate) && now > diaryItem.getDiary().dueDate"
                                    severity="danger" icon="pi pi-exclamation-triangle" [rounded]="true" value="Overdue" />
                                <p-tag *ngIf="diaryItem.getDiary().closedDate != null" severity="secondary" icon="pi pi-check" [rounded]="true"
                                    value="Closed" />
                            </td>
                            <td>{{diaryItem.getDiary().closedDate | date:'shortDate'}}</td>
                            <td>{{diaryItem.getDiary().subject}}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="rowexpansion" let-diaryItem>
                        <tr>
                            <td colspan="5">
                                <div class="flex flex-column">
                                    <div class="flex flex-row m-2">
                                        <div>
                                            Created: {{diaryItem.getDiary().createdDate | date:'shortDate'}}
                                        </div>
                                    </div>
                                    <div class="flex flex-row gap-2 w-full">
                                        <div class="diary-body h-9rem flex-1 border-solid text-sm border-round border-200 p-2 pl-4 pr-4 overflow-y-scroll overflow-x-hidden" style="min-width:0" [innerHtml]="diaryItem.getDiary().body"></div>
                                        <div class="flex flex-shrink-0 flex-column gap-2" style="width:3rem">
                                            <p-button [text]="true" icon="pi pi-external-link" pTooltip="Go to related item" tooltipPosition="left" (click)="diaryItem.goToRelatedItem()"></p-button>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </p-tabPanel>
    </p-tabView>
    

</div>
